<template>
    <v-form>
        <span class="text-subtitle-1 font-weight-medium">{{ $t(`details`) }} </span>
        <v-row>
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="product.pickUpPoint"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('cruises.departure_port')}`"
                    hide-details
                />
            </v-col>
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="product.dropOffPoint"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('cruises.arrival_port')}`"
                    hide-details
                />
            </v-col>
            <v-col :md="2" cols="12">
                <v-text-field
                    v-model="product.cruiseLine"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('cruises.cruise_line')}`"
                    hide-details
                />
            </v-col>
            <v-col :md="2" cols="12">
                <v-text-field
                    v-model="product.shipName"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('cruises.ship_name')}`"
                    hide-details
                />
            </v-col>
            <v-col :md="2" cols="12">
                <v-text-field
                    v-model="product.cabinCategory"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('cruises.cabin_category')}`"
                    hide-details
                />
            </v-col>
            <v-col :md="2" cols="12">
                <v-text-field
                    v-model="product.cabinTypeName"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('cruises.cabin_type_name')}`"
                    hide-details
                />
            </v-col>
            <v-col :md="2" cols="12">
                <v-text-field
                    v-model="product.deckName"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('cruises.deck_name')}`"
                    hide-details
                />
            </v-col>
            <v-col :md="2" cols="12">
                <v-text-field
                    v-model="product.deckNumber"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('cruises.deck_number')}`"
                    hide-details
                />
            </v-col>
            <v-col :md="2" cols="12">
                <v-text-field
                    v-model="product.cabinNumber"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('cruises.cabin_number')}`"
                    hide-details
                />
            </v-col>
        </v-row>
    </v-form>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class OfflineServiceFormCruise extends Vue {
        @Prop() productType
        @Prop() tourists
        @VModel() product
    }

    export default OfflineServiceFormCruise
</script>
